module.exports = __webpack_public_path__ + "img/account.022f1087.png";